import { NavController } from '@ionic/angular';
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, Input, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import {
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AutoCheckoutService } from 'src/app/services/auto-checkout/auto-checkout.service';
import { PageStateService } from 'src/app/services/page-state.service';
import { CountryCodeModalComponent } from '../../shared/modals/country-code-modal/country-code-modal.component';
import { CountryCode } from 'src/app/models/country-code';
import { ThemeService } from 'src/app/services/client/theme/theme.service';

@Component({
  selector: 'customer-details-form',
  templateUrl: './dutyfree-customer-details-form.component.html',
  styleUrls: ['./dutyfree-customer-details-form.component.scss'],
})
export class DutyfreeCustomerDetailsFormComponent implements OnInit {
  @Input() storeId: string;
  public form_data: any[];
  public validBdate: any;
  public formFields: any[];
  public formQuestionData = true;
  public minPickupDate: any;
  public maxPickupDate: any;
  public form = new FormGroup({});
  public selectedCountryCode: CountryCode;
  private questionSet: any;
  public currentHeaderData: any = {
    modal: true,
    backIcon: true,
    marl0: true,
    title: 'autocheckout_form.header',
  };

  constructor(
    private autoCheckoutService: AutoCheckoutService,
    private modalController: ModalController,
    private pageStateService: PageStateService,
    private navControl: NavController,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    this.selectedCountryCode = this.themeService.getDefaultCountry;
    this.form_data = [];
    this.questionSet = [];
    this.updatePageState();
  }

  closeModal() {
    // this.airportListService.setSelectedAirport(selectedAirport.airportCode);
    this.modalController.dismiss();
  }

  updatePageState() {
    this.autoCheckoutService
      .getAutoCheckoutForm(this.storeId)
      .subscribe((response) => {
        const currentDate = new Date();
        const today = new Date();
        const currentBdate = new Date();
        this.minPickupDate = formatDate(
          currentDate.setSeconds(
            currentDate.getSeconds() + parseInt(response.pickup_start_time, 10)
          ),
          'yyyy-MM-dd',
          'en-US'
        );
        const numberOfYearToSubstract = 18;
        this.validBdate = formatDate(
          currentBdate.setFullYear(
            currentBdate.getFullYear() - numberOfYearToSubstract
          ),
          'yyyy-MM-dd',
          'en-US'
        );
        this.maxPickupDate = formatDate(
          today.setSeconds(
            today.getSeconds() + parseInt(response.pickup_end_date, 10)
          ),
          'yyyy-MM-dd',
          'en-US'
        );
        if (response.questions && response.questions.length > 0) {
          this.form_data = response.questions;

          for (const formField of this.form_data) {
            this.form.addControl(formField.name, this.getValidator(formField));
            this.questionSet[formField.name] = [];
            this.questionSet[formField.name].label = formField.question;
            this.questionSet[formField.name].id = formField.id;
          }
          this.formFields = this.form_data;
        } else {
          this.formQuestionData = false;
        }
      });
  }
  submitRequest() {
    const requestData = [];

    Object.keys(this.form.value).forEach((key) => {
      requestData.push({
        answer:
          this.questionSet[key].id !== 24
            ? this.form.value[key]
            : this.selectedCountryCode.dialCode + '-' + this.form.value[key],
        question: this.questionSet[key].label,
        questionId: this.questionSet[key].id,
      });
    });

    this.pageStateService.setReloadAll();

    this.modalController.dismiss({
      formInfo: requestData,
    });
  }

  private getValidator(formField: any): any {
    switch (formField.name) {
      case 'email':
        return new FormControl('', [Validators.required, Validators.email]);
      case 'phone_number':
        return new FormControl('', [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
        ]);
      case 'pickup_date':
        return new FormControl('', [
          Validators.required,
          this.dateRangeValidator(this.minPickupDate, this.maxPickupDate),
        ]);
      default:
        return new FormControl('', [Validators.required]);
    }
  }

  private dateRangeValidator(minDate: any, maxDate: any) {
    return (control: FormControl) => {
      const currentDate = control.value;
      if (currentDate) {
        const date = new Date(currentDate);
        const inputDate = formatDate(
          date.setDate(date.getDate()),
          'yyyy-MM-dd',
          'en-US'
        );
        if (inputDate < minDate || inputDate > maxDate) {
          return { dateRange: true };
        }
      }
      return null;
    };
  }
  async selectCountryCode() {
    const modal = await this.modalController.create({
      component: CountryCodeModalComponent,
    });
    modal.present();

    const { data } = await modal.onWillDismiss();
    this.selectedCountryCode = data || this.selectedCountryCode;
  }
}
